import { ChartFacade } from '@mode/charts/contract';
import { CompiledField } from '@mode/shared/util-switch';
import { DomainLoader } from './colors-modal.component';
import * as ColorModalHelpers from './colors-modal-helpers';
import { RenderDataModel } from '@mode/charts/util-vegas';
import { FlamingoTypes } from '@mode/shared/contract-common';
import { Encoding } from '@mode-vegas/vegas';

export class RenderDataModelDomainLoader implements DomainLoader {
  constructor(
    private encoding: Encoding,
    private renderModel: RenderDataModel,
    private view: FlamingoTypes.ModeView
  ) {}

  fetchDomain(
    chartFacade: ChartFacade,
    currentField: CompiledField,
    onResult: (result: any[]) => void,
    onError: (error: string) => void
  ): void {
    const colorDomain = ColorModalHelpers.resolveColorDomain(this.encoding, this.renderModel, this.view, currentField);
    onResult(colorDomain);
  }
}
